import React from 'react'
import { useDownloadsToggleNav } from './DownloadsNavButton.context'
import { GridItem, HideContainer, NavButton } from './DownloadsNavButton.styles'

/**
 * The DownloadsNavButton's component.
 */
const DownloadsNavButton = () => {
  const toggle = useDownloadsToggleNav()

  const handleOpen = () => toggle()

  return (
    <HideContainer>
      <GridItem xs={2} sm={1}>
        <NavButton onClick={handleOpen} />
      </GridItem>
    </HideContainer>
  )
}

export default DownloadsNavButton
